import React, { useEffect, useState } from 'react';
import style from './scss/customer.module.scss';
import ContentLayout from '../../layout/contentLayout';
import { assets, leftnavassets } from '../../styles/assets/assets';
import WorktualTab from '../../components/custom_components/worktualTab';
import Journey from './journey';
import Upcoming from './upcoming';
import DonutChart from '../../components/custom_components/apexChartsTypes/donutChart';
import Speedometer from './speedometer';
import WorktualSearch from '../../components/custom_components/woktualSearch';
import ApexLineChart from '../../components/custom_components/apexChartsTypes/lineChart';
import { getCustomerProfileAvgSpending, getCustomerProfileAvgVisit, getCustomerProfileChurn, getCustomerProfileClv, getCustomerProfileEngagement, getCustomerProfileId, getCustomerProfileSummary } from '../../apiservice/profileInfo';
import moment from 'moment';
import { dashboardAction } from '../../store/slices/dashboard';
import { useDispatcher } from '../../custom_hooks/use_app_dispatch';
import { useDispatch, useSelector } from 'react-redux';
import Loaders from '../../components/loader/loader';
import aiicon from "../../styles/assets/images/aiicon.svg";

const Customer_Profile = () => {

    const year = 2022;
    const from = moment().year(year).startOf('year').format('YYYY-MM-DD');
    const currentDate = moment().year(2025).format('YYYY-MM-DD'); // asume 2019 
    const [startDate, setStartDate] = useState<any>(from);
    const [endDate, setEndDate] = useState<any>(currentDate);
    const dispatch = useDispatcher();
    const storeCustomerIds = useSelector((s: any) => s.dashboardReducer.customerId || []);
    const [loader, setLoader] = useState(false);
    const [nameList, setNameList] = useState<any[]>([]);         // full list from API
    const [filteredList, setFilteredList] = useState<any[]>([]); // list after search filter
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [selectedSubAcctId, setSelectedSubAcctId] = useState<number | string | null>(null);
    const [profileSummary, setProfileSummary] = useState<any | null>(null);
    const { customerId } = useSelector((store: any) => store.dashboardReducer)

    const [engagementScore, setEngagementScore] = useState<any | null>(null);
    const [churnScore, setChurnScore] = useState<any | null>(null);
    const [series, setSeries] = useState<number[]>([]);
    const [labels, setLabels] = useState<string[]>([]);
    const [categories, setCategories] = useState<any[]>([]);
    const [seriesline, setSeriesline] = useState<any[]>([]);
    const [categories1, setCategories1] = useState<any[]>([]);
    const [seriesline1, setSeriesline1] = useState<any[]>([]);
    const tabs = [
        { label: 'Journey', content: <Journey /> },
        { label: <div style={{ display: "flex", alignItems: "center", gap: 4 }}><img src={aiicon} alt="" />Upcoming</div>, content: <Upcoming /> }
    ]


    // ⏩ Initial fetch
    useEffect(() => {
        if (startDate && endDate) {
            callApis(startDate, endDate);
        }
    }, [startDate, endDate]);

    const callApis = (startDate: Date, endDate: Date) => {
        if (!startDate || !endDate) return;

        const body = {
            domainId: null,
            fromYear: moment(startDate).format("YYYY-MM-DD"),
            toYear: moment(endDate).format("YYYY-MM-DD"),
        };

        getCustomerProfileIdData(body);
    };

    // ⏩ Fetch Customer Profile IDs
    const getCustomerProfileIdData = async (body: any) => {
        try {
            setLoader(true);
            const res = await getCustomerProfileId(body);

            if (res?.data?.statusCode === 200) {
                const x: any[] = res?.data?.response ?? [];

                const normalized = x.map((it: any) => ({
                    ...it,
                    Sub_Acct_Id: it.Sub_Acct_Id ?? it.sub_Acct_Id ?? it.SubAcctId ?? null,
                }));

                setNameList(normalized);
                setFilteredList(normalized);
                dispatch(dashboardAction.setCustomerId(normalized));
                // ✅ auto-select first ID and fetch summary
                if (normalized.length > 0) {
                    handleSelect(normalized[0]);
                }
            } else {
                setNameList([]);
                setFilteredList([]);
            }
        } catch (error) {
            console.error("Error fetching Customer Profile Id:", error);
            setNameList([]);
            setFilteredList([]);
        } finally {
            setLoader(false);
        }
    };

    // ⏩ Handle Click
    const handleSelect = (item: any) => {
        const subId = item?.Sub_Acct_Id ?? item?.sub_Acct_Id ?? item;
        if (!subId) return;

        setSelectedSubAcctId(subId);

        const body = {
            domainId: null,
            fromYear: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
            toYear: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
            Sub_Acct_Id: subId,
        };

        getCustomerProfileSummaryData(body);
        getCustomerProfileEngagementData(body)
        getCustomerProfileClvData(body)
        getCustomerProfileAvgSpendingData(body)
        getCustomerProfileChurnData(body)
        getCustomerProfileAvgVisitData(body)
    };

    // ⏩ Fetch Summary by Sub ID
    const getCustomerProfileSummaryData = async (body: any) => {
        try {
            setLoader(true);
            const res = await getCustomerProfileSummary(body);

            if (res?.data?.statusCode === 200) {
                const x = res?.data?.response ?? null;
                setProfileSummary(x[0]);
            } else {
                setProfileSummary(null);
            }
        } catch (error) {
            console.error("Error fetching Customer Profile Summary:", error);
            setProfileSummary(null);
        } finally {
            setLoader(false);
        }
    };

    const getCustomerProfileEngagementData = async (body: any) => {
        try {
            setLoader(true);
            const res = await getCustomerProfileEngagement(body);

            if (res?.status === 200) {
                setEngagementScore(res.data.response[0].Engagement_Score);
            } else {
                setEngagementScore(null);
            }
        } catch (error) {
            console.error("Error fetching Customer Profile Summary:", error);
            setEngagementScore(null);
        } finally {
            setLoader(false);
        }
    };

    const getCustomerProfileClvData = async (body: any) => {
        try {
            setLoader(true);
            const res = await getCustomerProfileClv(body);

            if (res?.data?.statusCode === 200) {
                const { ExpectedCLV, Actual_CLV } = res.data.response[0];

                // ✅ set series and labels for DonutChart
                setSeries([ExpectedCLV, Actual_CLV]);
                setLabels(["Expected CLV", "Actual CLV"]);
            } else {
                setSeries([]);
                setLabels([]);
            }
        } catch (error) {
            console.error("Error fetching Customer Profile CLV:", error);
            setSeries([]);
            setLabels([]);
        } finally {
            setLoader(false);
        }
    };

    const getCustomerProfileAvgSpendingData = async (body: any) => {
        try {
            setLoader(true);
            const res = await getCustomerProfileAvgSpending(body);

            if (res?.data?.statusCode === 200 && res.data.response?.length > 0) {
                const data = res.data.response[0];
                const months = Object.keys(data); // ["Jan", "Feb", ...]
                const values = Object.values(data) as number[]; // [49.5, 49.5, ...]

                setCategories(months);

                // ApexCharts series format
                setSeriesline([
                    {
                        name: "Average Spending",
                        data: values
                    }
                ]);
            } else {
                setCategories([]);
                setSeriesline([]);
            }
        } catch (error) {
            console.error("Error fetching Customer Avg Spending:", error);
            setCategories([]);
            setSeriesline([]);
        } finally {
            setLoader(false);
        }
    };

    const getCustomerProfileChurnData = async (body: any) => {
        try {
            setLoader(true);
            const res = await getCustomerProfileChurn(body);

            if (res?.status === 200) {
                console.log('56789')
                setChurnScore(res.data.response[0].churn_risk_score);
            } else {
                setChurnScore(null);
            }
        } catch (error) {
            console.error("Error fetching Customer Profile Summary:", error);
            setChurnScore(null);
        } finally {
            setLoader(false);
        }
    };

    const getCustomerProfileAvgVisitData = async (body: any) => {
        try {
            setLoader(true);
            const res = await getCustomerProfileAvgVisit(body);

            if (res?.data?.statusCode === 200 && res.data.response?.length > 0) {
                const data = res.data.response[0];
                // const months = Object.keys(data); // ["Jan", "Feb", ...]
                const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"]
                const values = Object.values(data) as number[]; // [49.5, 49.5, ...]

                setCategories1(months);

                // ApexCharts series format
                setSeriesline1([
                    {
                        name: "Average visits",
                        data: values
                    }
                ]);
            } else {
                setCategories1([]);
                setSeriesline1([]);
            }
        } catch (error) {
            console.error("Error fetching Customer Avg Spending:", error);
            setCategories1([]);
            setSeriesline1([]);
        } finally {
            setLoader(false);
        }
    };
    // 6) Search handler (simple client-side filter)
    const handleSearch = (val: string | React.ChangeEvent<HTMLInputElement> | any) => {
        // normalize incoming value to a plain string
        let value = "";

        if (typeof val === "string") {
            value = val;
        } else if (val && typeof val === "object") {
            if ("target" in val && val.target && "value" in val.target) {
                value = String(val.target.value);
            } else if ("value" in val) {
                value = String(val.value);
            } else {
                // last resort: try to stringify (useful for debugging)
                value = JSON.stringify(val);
            }
        } else {
            value = String(val ?? "");
        }

        value = value.trim();
        setSearchQuery(value);

        if (!value) {
            setFilteredList(nameList);
            return;
        }

        const q = value.toLowerCase();

        const filtered = nameList.filter((item) => {
            // make sure we're searching primitive fields only
            const id = String(item?.Sub_Acct_Id ?? item?.sub_Acct_Id ?? "");
            const alt = String(item?.name ?? item?.displayName ?? "");
            return id.toLowerCase().includes(q) || alt.toLowerCase().includes(q);
        });

        setFilteredList(filtered);
    };
    return (
        <>
            {loader ? (
                <Loaders />
            ) : (
                <ContentLayout noPadding={true}>
                    <div className={style.titlearea}>
                        <div className={style.titlename}>Customer Profiles</div>
                        <div className={style.titledesc}>All customer insights in one place- profile, activity, and interactions.</div>
                    </div>
                    <div className={style.customercontainer}>
                        <div className={style.customerinsigh}>
                            <div className={style.sigsearch}>
                                {/* <input type="text" placeholder='Search '/> */}
                                {/* <WorktualSearch onChange={undefined} value={''} /> */}
                                <WorktualSearch
                                    value={searchQuery}
                                    onChange={(v: any) => handleSearch(v)}
                                    placeholder="Search SUB ID"
                                />
                                <span>
                                    <img src={assets.search_icon} alt="search_icon" />
                                </span>
                            </div>
                            <div className={style.namelist}>
                                {filteredList.map((item: any, index: number) => (
                                    <div
                                        key={item.Sub_Acct_Id ?? index}
                                        className={style.willamtopbar}
                                        onClick={() => handleSelect(item)}
                                        style={{
                                            cursor: "pointer",
                                            background: selectedSubAcctId === item.Sub_Acct_Id ? "#E3E4E5" : undefined,
                                            borderRadius: selectedSubAcctId === item.Sub_Acct_Id ? "25px" : undefined,
                                        }}
                                    >
                                        <span
                                            className={
                                                index % 3 === 0 ? "" : index % 3 === 1 ? style.blue : style.pinkcw
                                            }
                                        >
                                            ID
                                        </span>
                                        <p>{item.Sub_Acct_Id}</p>
                                    </div>
                                ))}

                                {filteredList.length === 0 && <div>No accounts found</div>}
                            </div>
                        </div>
                        <div className={style.customerleftpanel}>
                            <div className={style.topbarpanel}>
                                <h4>ID</h4>
                                <h3>{profileSummary?.Sub_Acct_Id}<span>{profileSummary?.cluster_name}</span></h3>
                                <p>{profileSummary?.location}</p>
                            </div>
                            <div className={style.aisummaryincustomerpanel}>
                                <h3>AI Summary</h3>
                                <div dangerouslySetInnerHTML={{ __html: profileSummary?.summary || "" }} />
                            </div>
                            {/* <div className={style.purchaselist}>
                            <div className={style.pruchase}>
                                <img src={leftnavassets.purchase_list1} alt="" />
                                <p>5 purchase</p>
                            </div>
                            <div className={style.pruchase}>
                                <img src={leftnavassets.purchase_list2} alt="" />
                                <p>17 App</p>
                            </div>
                            <div className={style.pruchase}>
                                <img src={leftnavassets.purchase_list3} alt="" />
                                <p>7 Social</p>
                            </div>
                            <div className={style.pruchase}>
                                <img src={leftnavassets.purchase_list4} alt="" />
                                <p>19 Email</p>
                            </div>
                        </div> */}
                            <div className={style.generalinformation}>
                                <div className={style.titlarea}>
                                    <h3>General Information</h3>
                                    <p className={style.createmanage}> From SIM type to data and voice usage, gives everything you need to know for a 360° customer view. </p>
                                </div>
                                <div className={style.generaldetails}>
                                    <span>Sim Type</span>
                                    <p>{profileSummary?.SIM_TYPE}</p>
                                </div>
                                <div className={style.generaldetails}>
                                    <span>Subscriber Type</span>
                                    <p>{profileSummary?.subscriber_type}</p>
                                </div>
                                <div className={style.generaldetails}>
                                    <span>Account Validity Date</span>
                                    <p>
                                        {profileSummary?.Account_validity_date
                                            ? moment(profileSummary.Account_validity_date).format("DD-MMM-YYYY")
                                            : "N/A"}
                                    </p>                            </div>
                                <div className={style.generaldetails}>
                                    <span>Call Duration</span>
                                    <p>{profileSummary?.voice_Total_Call_Duration} Sec</p>
                                </div>
                                <div className={style.generaldetails}>
                                    <span>Data Usage</span>
                                    <p>
                                        {profileSummary?.GPRS_Total_Used_Bytes
                                            ? (Number(profileSummary.GPRS_Total_Used_Bytes) / (1024 ** 3)).toFixed(1) + " GB"
                                            : "0 GB"}
                                    </p>
                                </div>
                                <div className={style.generaldetails}>
                                    <span>SMS Usage</span>
                                    <p>{profileSummary?.total_number_of_sms}</p>
                                </div>
                                <div className={style.generaldetails}>
                                    <span>Network Usage Type</span>
                                    {profileSummary?.network_usage
                                        ?.replace(/^\[|\]$/g, "")
                                        .replace(/'/g, "")}
                                </div>
                            </div>
                            <div className={style.retentionoffer}>
                                <div className={style.titlarea}>
                                    <h3>Purchased Plans</h3>
                                    <p>Track what works. Boost what converts.</p>
                                </div>
                                <div className={style.netprices}>
                                    {profileSummary?.purchased_bundles
                                        ?.replace(/^\[|\]$/g, "")
                                        .replace(/'/g, "")
                                        .split(",")
                                        .map((bundle: string, idx: number) => (
                                            <p key={idx}>{bundle.trim()}</p>
                                        ))}
                                </div>
                            </div>
                            <div className={style.analyticmetric}>
                                <p>Analytics Metrics</p>
                            </div>
                            <div className={style.chartcontainer}>
                                <div className={style.clvwrapbody}>
                                    <h3>Engagement score</h3>
                                    <Speedometer value={engagementScore} gaugeColors={["#F22E57", "#575CFF", "#E3E4E5"]} />
                                    <div className={style.labelsgrp}>
                                        <h3>{engagementScore}%</h3>
                                    </div>
                                </div>
                                <div className={style.clvwrapbody}>
                                    <h3>CLV</h3>

                                    <DonutChart
                                        key={JSON.stringify(series) + JSON.stringify(labels)}
                                        series={series}
                                        labels={labels}
                                        colors={["#438DBE", "#2CA02C"]}
                                        toastSuffix=" Kr"
                                    />

                                    <div className={style.labelsgrp}>
                                        <div className={style.indvidualchartlabel}>
                                            <span className={style.dot} style={{ backgroundColor: "#438DBE" }}></span>
                                            <p>Expected CLV</p>
                                        </div>
                                        <div className={style.indvidualchartlabel}>
                                            <span className={style.dot} style={{ backgroundColor: "#2CA02C" }}></span>
                                            <p>Actual CLV</p>
                                        </div>
                                    </div>
                                </div>
                                <div className={style.clvwrapbody}>
                                    <h3>Average spending</h3>
                                    <ApexLineChart
                                        categories={categories}
                                        series={seriesline}
                                        colors={["#FF5733"]}
                                        title="Average Spending"
                                        markersSize={4}
                                        toastSuffix='Kr'
                                    />
                                </div>
                                <div className={style.clvwrapbody}>
                                    <h3>Churn risk</h3>
                                    <Speedometer value={churnScore} gaugeColors={["#7423D7", "#FF5733", "#C70039"]} needleColor={["#F22E57"]} />
                                    <div className={style.labelsgrp}>
                                        <h3>{churnScore}%</h3>
                                    </div>
                                </div>
                                <div className={style.clvwrapbody}>
                                    <h3>Average visits</h3>
                                    <ApexLineChart categories={categories1}
                                        series={seriesline1}
                                        colors={["#FF5733"]} title="Hourly Sales & Revenue" markersSize={1} />
                                </div>
                            </div>
                        </div>
                        <div className={style.customerightpanel}>
                            <WorktualTab tabs={tabs} className='custompro' />
                        </div>
                    </div>
                </ContentLayout>
            )}



        </>
    )
}
export default Customer_Profile;
